/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { MdmDeduplicationResult } from './MdmDeduplicationResult';
import {
    MdmDeduplicationResultFromJSON,
    MdmDeduplicationResultFromJSONTyped,
    MdmDeduplicationResultToJSON,
    MdmDeduplicationResultToJSONTyped,
} from './MdmDeduplicationResult';

/**
 * 
 * @export
 * @interface DeduplicationResponse
 */
export interface DeduplicationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeduplicationResponse
     */
    success?: boolean;
    /**
     * 
     * @type {MdmDeduplicationResult}
     * @memberof DeduplicationResponse
     */
    data?: MdmDeduplicationResult;
    /**
     * 
     * @type {string}
     * @memberof DeduplicationResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof DeduplicationResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof DeduplicationResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof DeduplicationResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof DeduplicationResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the DeduplicationResponse interface.
 */
export function instanceOfDeduplicationResponse(value: object): value is DeduplicationResponse {
    return true;
}

export function DeduplicationResponseFromJSON(json: any): DeduplicationResponse {
    return DeduplicationResponseFromJSONTyped(json, false);
}

export function DeduplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeduplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : MdmDeduplicationResultFromJSON(json['data']),
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function DeduplicationResponseToJSON(json: any): DeduplicationResponse {
    return DeduplicationResponseToJSONTyped(json, false);
}

export function DeduplicationResponseToJSONTyped(value?: DeduplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': MdmDeduplicationResultToJSON(value['data']),
        'message': value['message'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

